import { CATEGORIES_SERVICE } from "@/services/categories.service.js";

const state = {getCategoriesOutput: {}, postCategoryOutput: false, putCategoryOutput: false, deleteCategoryByIdOutput: false, getCategoryByIdOutput: {}, getInflateCategoriesOutput: {}, getActiveCategoriesOutput: {}};

const actions = {
    //Service to get paginated categories
    getCategories({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getCategoriesRequest');

        CATEGORIES_SERVICE.getCategories(queryParams)
            .then(
                output => {
                    commit('getCategoriesSuccess', output);
                },
                error => {
                    commit('getCategoriesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create categories
    postCategory({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postCategoryRequest');

        CATEGORIES_SERVICE.postCategory(input)
            .then(
                output => {
                    commit('postCategorySuccess', output);
                },
                error => {
                    commit('postCategoryFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update categories
    putCategory({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putCategoryRequest');

        CATEGORIES_SERVICE.putCategory(input)
            .then(
                output => {
                    commit('putCategorySuccess', output);
                },
                error => {
                    commit('putCategoryFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete categories
    deleteCategoryById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteCategoryByIdRequest');

        CATEGORIES_SERVICE.deleteCategoryById(id)
            .then(
                output => {
                    commit('deleteCategoryByIdSuccess', output);
                },
                error => {
                    commit('deleteCategoryByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get categories by id
    getCategoryById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getCategoryByIdRequest');

        CATEGORIES_SERVICE.getCategoryById(id)
            .then(
                output => {
                    commit('getCategoryByIdSuccess', output);
                },
                error => {
                    commit('getCategoryByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Services to get grouped categories by brand
    getInflateCategories({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('getInflateCategoriesRequest');

        CATEGORIES_SERVICE.getCategoryByBrand('InflateYourImagination')
            .then(
                output => {
                    commit('getInflateCategoriesSuccess', output);
                },
                error => {
                    commit('getInflateCategoriesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getActiveCategories({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('getActiveCategoriesRequest');

        CATEGORIES_SERVICE.getCategoryByBrand('ActiveBrands')
            .then(
                output => {
                    commit('getActiveCategoriesSuccess', output);
                },
                error => {
                    commit('getActiveCategoriesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getCategories
    getCategoriesRequest(state) {
    },
    getCategoriesSuccess(state, output) {
        state.getCategoriesOutput = output;
    },
    getCategoriesFailure(state) {
        state.getCategoriesOutput = false;
    },

    //postCategory
    postCategoryRequest(state) {
        state.postCategoryOutput = null;
    },
    postCategorySuccess(state, output) {
        state.postCategoryOutput = true;
    },
    postCategoryFailure(state) {
        state.postCategoryOutput = false;
    },

    //putCategory
    putCategoryRequest(state) {
        state.putCategoryOutput = null;
    },
    putCategorySuccess(state, output) {
        state.putCategoryOutput = true;
    },
    putCategoryFailure(state) {
        state.putCategoryOutput = false;
    },

    //deleteCategoryById
    deleteCategoryByIdRequest(state) {
        state.deleteCategoryByIdOutput = null;
    },
    deleteCategoryByIdSuccess(state, output) {
        state.deleteCategoryByIdOutput = true;
    },
    deleteCategoryByIdFailure(state) {
        state.deleteCategoryByIdOutput = false;
    },

    //getCategoryById
    getCategoryByIdRequest(state) {
    },
    getCategoryByIdSuccess(state, output) {
        state.getCategoryByIdOutput = output;
    },
    getCategoryByIdFailure(state) {
        state.getCategoryByIdOutput = false;
    },

    //getCategoryByBrand
    getInflateCategoriesRequest(state) {
    },
    getInflateCategoriesSuccess(state, output) {
        state.getInflateCategoriesOutput = output;
    },
    getInflateCategoriesFailure(state) {
        state.getInflateCategoriesOutput = false;
    },
    getActiveCategoriesRequest(state) {
    },
    getActiveCategoriesSuccess(state, output) {
        state.getActiveCategoriesOutput = output;
    },
    getActiveCategoriesFailure(state) {
        state.getActiveCategoriesOutput = false;
    },
};

export const categories = {
    namespaced: true,
    state,
    actions,
    mutations
};